(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mcp-hadrill-featured-quotes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hadrill-quote-carousel')) {
    customElements.define('hadrill-quote-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        const track = this.querySelector('.hqc__track');
        const slides = [...this.querySelectorAll('.hqc__slide')];
        const dots = [...this.querySelectorAll('.hqc__dots button')];
        const status = this.querySelector('.hqc__status');
        if (!track || !slides.length) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const reduced = matchMedia('(prefers-reduced-motion: reduce)');
        let active = 0;
        let navigating = null;
        let drag = null;
        const setActive = (index, announce = false) => {
          active = index;
          slides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== index)));
          dots.forEach((dot, i) => i === index ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current'));
          if (announce) status.textContent = dots[index].dataset.announcement;
        };
        const go = (index) => {
          index = (index + slides.length) % slides.length;
          navigating = index;
          setActive(index, true);
          track.scrollTo({left:index * track.clientWidth, behavior:reduced.matches ? 'instant' : 'smooth'});
        };
        this.querySelector('.hqc__previous').addEventListener('click', () => go(active - 1), {signal});
        this.querySelector('.hqc__next').addEventListener('click', () => go(active + 1), {signal});
        dots.forEach((dot, i) => dot.addEventListener('click', () => go(i), {signal}));
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') { event.preventDefault(); go(active + 1); }
          if (event.key === 'ArrowLeft') { event.preventDefault(); go(active - 1); }
        }, {signal});
        track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => {
            if (navigating !== null) {
              if (Math.abs(track.scrollLeft - navigating * track.clientWidth) < 1) navigating = null;
              return;
            }
            setActive(Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth))));
          });
        }, {passive:true, signal});
        track.addEventListener('pointerdown', (event) => {
          navigating = null;
          if (event.pointerType !== 'mouse') return;
          drag = {x:event.clientX, left:track.scrollLeft};
          track.classList.add('is-dragging');
          track.setPointerCapture(event.pointerId);
        }, {signal});
        track.addEventListener('pointermove', (event) => {
          if (drag) track.scrollLeft = drag.left - (event.clientX - drag.x);
        }, {signal});
        const finishDrag = (event) => {
          if (!drag) return;
          const dx = drag.x - event.clientX;
          const origin = Math.round(drag.left / track.clientWidth);
          drag = null;
          track.classList.remove('is-dragging');
          go(Math.abs(dx) > 45 ? origin + Math.sign(dx) : origin);
        };
        track.addEventListener('pointerup', finishDrag, {signal});
        track.addEventListener('pointercancel', finishDrag, {signal});
        this.resizeObserver = new ResizeObserver(() => {
          navigating = active;
          track.scrollTo({left:active * track.clientWidth, behavior:'instant'});
        });
        this.resizeObserver.observe(track);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.scrollFrame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mcp-hadrill-founder"] && !Shopify.designMode) return;
  try {
    
  function initialiseFounderBios(scope) {
    scope.querySelectorAll('[data-founder-bio]').forEach((bio) => {
      if (bio.dataset.initialised) return;
      const button = bio.querySelector('[data-founder-toggle]');
      const story = bio.querySelector('.hf__story');
      const label = button.querySelector('[data-founder-label]');
      if (!story) return;
      bio.dataset.initialised = 'true';
      bio.classList.add('is-collapsible');
      button.hidden = false;
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        bio.classList.toggle('is-expanded', expanded);
        button.setAttribute('aria-expanded', String(expanded));
        label.textContent = expanded ? button.dataset.less : button.dataset.more;
      });
    });
  }
  initialiseFounderBios(document);
  document.addEventListener('shopify:section:load', (event) => {
    initialiseFounderBios(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mcp-hadrill-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.sliderReady) return;
    root.dataset.sliderReady='true';
    var track=root.querySelector('.hrev-slider__track');
    var controls=root.querySelector('.hrev-slider__controls');
    var prev=root.querySelector('[data-review-prev]');
    var next=root.querySelector('[data-review-next]');
    var reviews=Array.from(root.querySelectorAll('.hrev-slider__body')).map(function(body){
      var button=body.nextElementSibling;
      button.addEventListener('click',function(){
        var expanded=button.getAttribute('aria-expanded')!=='true';
        button.setAttribute('aria-expanded',String(expanded));
        button.textContent=expanded?button.dataset.less:button.dataset.more;
        body.classList.toggle('is-collapsed',!expanded);
      });
      return {body:body,button:button};
    });
    function updateReviews(){
      reviews.forEach(function(review){
        var expanded=review.button.getAttribute('aria-expanded')==='true';
        review.body.classList.toggle('is-collapsed',!expanded);
        var overflows=review.body.scrollHeight>parseFloat(getComputedStyle(review.body).lineHeight)*5+2;
        review.button.hidden=!overflows;
        if(!overflows) review.body.classList.remove('is-collapsed');
      });
    }
    function update(){
      var max=track.scrollWidth-track.clientWidth;
      controls.hidden=max<2;
      prev.disabled=track.scrollLeft<2;
      next.disabled=track.scrollLeft>=max-2;
    }
    function move(direction){
      var card=track.querySelector('.hrev-slider__card');
      if(!card) return;
      var gap=parseFloat(getComputedStyle(track).gap)||0;
      track.scrollBy({left:direction*(card.getBoundingClientRect().width+gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    }
    prev.addEventListener('click',function(){move(-1)});
    next.addEventListener('click',function(){move(1)});
    track.addEventListener('scroll',update,{passive:true});
    track.addEventListener('keydown',function(e){if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1)}});
    var observer=new ResizeObserver(function(){update();updateReviews()}); observer.observe(track);
    if(document.fonts) document.fonts.ready.then(updateReviews);
    updateReviews();
    root.addEventListener('shopify:section:unload',function(){observer.disconnect()},{once:true});
    update();
  }
  function boot(){document.querySelectorAll('.hrev-slider').forEach(init)}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();
})();
